import { jsxs as _jsxs, jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import Bool from "./types/bool";
import Float from "./types/float";
import Int from "./types/int";
import Varchar from "./types/varchar";
import Html from "./types/html";
import Images from "./types/image";
import Date from "./types/date";
import Datetimecombo from "./types/datetimecombo";
import Phone from "./types/phone";
import Currency from "./types/currency";
import Iframe from "./types/iframe";
import Relate from "./types/relate";
import TextArea from "./types/textarea";
import Url from "./types/url";
import Enum from "./types/enum";
import DynamicEnum from "./types/dynamicenum";
import RadioEnum from "./types/radioenum";
import Decimal from "./types/decimal";
import Address from "./types/address";
import MultiEnum from "./types/multienum";
var components = {
    TextField: Varchar,
    Checkbox: Bool,
    Float: Float,
    Integer: Int,
    HTML: Html,
    Images: Images,
    Date: Date,
    Datetime: Datetimecombo,
    Phone: Phone,
    Currency: Currency,
    IFrame: Iframe,
    Relate: Relate,
    TextArea: TextArea,
    URL: Url,
    DropDown: Enum,
    DynamicDropDown: DynamicEnum,
    Radio: RadioEnum,
    Decimal: Decimal,
    Address: Address,
    MultiSelect: MultiEnum,
};
var FieldComponent = function (_a) {
    var settings = _a.settings, type = _a.type, updated = _a.updated, error = _a.error, updateSettings = _a.updateSettings;
    var Component = components[type];
    if (!Component) {
        return _jsxs("div", { children: ["Composant non trouv\u00E9 pour le type ", type] });
    }
    var updateSetting = function (name, value) {
        updateSettings(name, value);
    };
    return (_jsx(Component, { settings: settings, type: type, updated: updated, error: error, updateSettings: updateSetting }));
};
export default function FieldType(_a) {
    var type = _a.type, error = _a.error, updated = _a.updated, settings = _a.settings, fieldTypeConfig = _a.fieldTypeConfig, updateSettings = _a.updateSettings;
    var updateFieldType = function (name, value) {
        updateSettings(name, value);
    };
    return (_jsx(_Fragment, { children: _jsx(FieldComponent, { settings: settings, type: type, updated: updated, error: error, updateSettings: updateFieldType }) }));
}
